// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VTEq","col":"styles_col__3ePj5","actions":"styles_actions__309ca","conflict":"styles_conflict__1uKCa"};